import { useParams } from 'react-router-dom';
import FileNotFound from '../FileNotFound';
import { getVideoMeta } from './videos';
import VimeoEmbed from './VimeoEmbed';

const VideoPage = ({ id }: any) => {
  const video = getVideoMeta(id);

  if (!video) {
    return <FileNotFound />;
  }

  // Only vimeo supported atm
  return (
    <div style={{ flex: 1 }}>
      <VimeoEmbed id={id} title={video.name} />
    </div>
  );
};

export default () => {
  let { id } = useParams<any>();

  return <VideoPage id={id} />;
};
